import { storage } from '@itau-loans-www/utils'

const storageName = `${APP_NAME}_${BUILD_ENV}`

export default (partner = '') => {
  const implementation_team =
    'produtos-consignados:conquista-digital-de-clientes'

  if (!partner) {
    const partnerFromStorage = storage.session.getItem(
      `${storageName}_leadData`
    )?.partner
    partner = partnerFromStorage
  }

  const partnerMap = (partner = '') => {
    const map = {
      assai: 'assai',
      pirelli: 'pirelli',
      atacadao: 'atacadao',
      carrefour: 'carrefour',
      magalu: 'magazine-luiza',
      telhaNorte: 'telhanorte',
      crediffato: 'crediffato'
    }

    const currentMap = map[partner]

    return currentMap ? { flow: partner } : {}
  }

  return {
    implementation_team,
    ...partnerMap(partner)
  }
}
